import React from "react";
import { useModalContext } from "common/contexts";
import ConfirmStepActionBulkModal from "./ConfirmStepActionBulkModal";
import InvestigationEventListModal from "./InvestigationEventList";
export const MODAL_TYPES = {
  BULK_PERFORM_STEP_ACTION: "BULK-PERFORM-STEP-ACTION",
  INVESTIGATION_EVENT_LIST: "INVESTIGATION-EVENT-LIST"
};
function ProceduresModals() {
  const { modal, entity, setModal, setEntity } = useModalContext();
  const onClose = () => {
    setModal(void 0);
    setEntity(void 0);
  };
  switch (modal) {
    case MODAL_TYPES.INVESTIGATION_EVENT_LIST:
      return /* @__PURE__ */ React.createElement(InvestigationEventListModal, { onClose, eventIds: entity == null ? void 0 : entity.eventIds });
    case MODAL_TYPES.BULK_PERFORM_STEP_ACTION:
      return /* @__PURE__ */ React.createElement(
        ConfirmStepActionBulkModal,
        {
          stepId: entity == null ? void 0 : entity.stepId,
          eventIds: entity == null ? void 0 : entity.eventIds,
          stepActionType: entity == null ? void 0 : entity.stepActionType,
          onClose
        }
      );
    default:
      return null;
  }
}
export default ProceduresModals;
